import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { constants } from '@klarna/bubble-ui';
import { Flex } from '@klarna/mp-ui';
import { Gutter } from 'moet-core';

const BodyGutter = () => (
  <Flex
    style={{
      borderBottomColor: constants.Colors.DIVIDER,
      borderStyle: 'solid',
      borderWidth: 0,
      borderBottomWidth: 1,
    }}
  >
    <Gutter />
  </Flex>
);

export default BodyGutter;
